import React, { ReactNode } from 'react'
import { DispatchProp } from 'react-redux'
import { connectRedux } from '../../../helpers/connectRedux'
import { RouteComponentProps } from '../../../helpers/withRouter'
import Select from 'react-select'
import { Button, Page, Spinner } from '../../../components'
import { images } from '../../../images'
import literalsService from '../../../services/literals-service'
import { fetchUnsubscribeReasonsAction, setNotificationAction, signOutAction, unsubscribeAction } from '../../../store/actions'
import { IStoreState, IUnsubscribeState } from '../../../store/states'
import StyledArticle from './styles'
import { appsStyleSelected } from '../../../helpers/app'
import { AuthenticatedRoutable } from '../../../models'
import { AnyAction } from 'redux'

interface IProps extends IUnsubscribeState, RouteComponentProps, DispatchProp<any> {}

interface IState {
  reason: number
}

class Unsubscribe extends AuthenticatedRoutable<IProps, IState> {

  private get unsubscribedOptions() {
    const { reasons } = this.props
    const reasonsList: any[] = []
    reasons.forEach((reason) => {
      reasonsList.push({ label: reason.name, value: reason.id })
    })
    return reasonsList
  }

  private get buttonIsDisabled(): boolean {
    return this.state.reason === -1
  }

  constructor(props: IProps) {
    super(props)

    this.state = {
      reason: -1
    }
  }

  public componentDidMount() {
    const { dispatch } = this.props

    super.componentDidMount()
    dispatch(fetchUnsubscribeReasonsAction())
  }

  public render(): ReactNode {
    const { isLoading } = this.props

    return (
      <Page>
        <Page className={ `authenticated ${appsStyleSelected?.style}` }>
          <StyledArticle>
            {
              isLoading ?
              <article className="spinner-container">
                <Spinner />
              </article>
              :
              <>
                <img src={ images['goBack'] } className='backButton' onClick={ this.handleGoBack } />
                <form onSubmit={ e => e.preventDefault() }>
                  <section>
                    <h3>{ literalsService.get('unsubscribe', true) }</h3>
                    <label>{ literalsService.get('sadToSeeYouGo', true) }</label>
                    <Select className='unsubscribedOptions' options={this.unsubscribedOptions} onChange={this.handleChangeUnsubscribedOptions} />
                    <Button
                      title={ literalsService.get('save', true) }
                      onPress={ this.handleUnsubscribe }
                      className={ 'saveButton' }
                      filled
                      upper
                      isDisabled={ this.buttonIsDisabled }
                    />
                  </section>
                </form>
              </>
            }
          </StyledArticle>
        </Page>
      </Page>
    )
  }

  private handleGoBack = (): void => {
    history.back()
  }

  private handleChangeUnsubscribedOptions = (reason: any) => {
    this.setState({reason: reason.value})
  }

  private handleUnsubscribe = () => {
    const { dispatch } = this.props
    dispatch(unsubscribeAction(this.state.reason))
    dispatch(setNotificationAction({
      label: literalsService.get('unsubscribedSuccess', true),
      isError: false
    }))
    dispatch(signOutAction())
  }
}

const mapStateToProps = ({ unsubscribe }: IStoreState) => ({
  ...unsubscribe
})

export default connectRedux(mapStateToProps, Unsubscribe)
